import { TxtAttach } from '../core/index.model';

export class CitNews {
    constructor() { }
    MenuType: string;
    CitNewsID: string;
    JurisID: number;
    NewsType: string;
    Subject: string;
    Description: string;
    Authority: string;
    FromDttmUTC?: Date;
    ToDttmUTC?: Date;
    IsMain: number;
    CreatedPFID?: string;
    CreatedDttmUTC: Date;
    ModifiedPFID?: string;
    ModifiedDttmUTC?: Date;
    NewsTypeDesc: string;
    TxtAttach: TxtAttach;
    IsAttachmentAvailable: boolean;
}

export class CitNewsType {
    NewsTypeDesc: string;
    citNews: CitNews[]
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/citnews.model.ts